import { ApolloError } from "@apollo/client"
import { message } from "antd"
import _ from "lodash"
import { parseISO } from "date-fns"
import { format } from "date-fns-tz"
import i18n from "../i18n"

/**
 * 백엔드는 에러 메시지를 한국어로 내려주므로(다른 서비스와 공유), 화면에서는
 * errorCode를 i18n 키(`error.<CODE>`)로 바꿔 현재 UI 언어로 보여준다.
 * 코드는 `ILLEGAL_STATE/STATUS/PREPARED`, `TX_ERROR/23505`, `DIAG_NO_LANG:[sv]`
 * 처럼 세분화될 수 있어 뒤에서부터 잘라가며 가장 구체적인 번역을 찾는다.
 */
export const translateErrorCode = (code?: string): string | null => {
  if (!code) return null
  const parts = String(code).split(":")[0].split("/")
  for (let i = parts.length; i > 0; i--) {
    const key = `error.${parts.slice(0, i).join("/")}`
    const translated = i18n.t(key, { ns: "CHECK_MANAGER", defaultValue: "" }) as string
    if (translated) return translated
  }
  return null
}

export const formatGqlError = (code?: string, fallback?: string): string => {
  const translated = translateErrorCode(code)
  if (translated) return translated
  if (fallback) return code ? `${code}: ${fallback}` : fallback
  return code || i18n.t("error.UNKNOWN", { ns: "CHECK_MANAGER", defaultValue: "Unexpected error" })
}

export const handleGqlError = (
  e: ApolloError,
  onMessage: any = (msg) => {
    message.error(msg)
  }
) => {
  if (typeof onMessage !== "function") {
    onMessage = (msg) => message.error(msg)
  }
  const { graphQLErrors, networkError } = e
  if (networkError) onMessage(networkError.message)
  if (graphQLErrors)
    graphQLErrors.forEach((err) => {
      const code = _.get(err, "extensions.code") as string
      onMessage(formatGqlError(code, err.message))
    })
}

export const formatDateTime = (value) =>
  value ? format(parseISO(value), "yyyy-MM-dd HH:mm:ss", { timeZone: "Asia/Seoul" }) : ""

export const round = (num: number | string, digits: number = 1) => {
  return +Number(num).toFixed(digits)
}
